/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { TermsAndPolicies } from '../../data/types';

export type TermsAndPoliciesState = {
    termsAndPolicies?: TermsAndPolicies,
    acceptedTOS?: boolean,
}

export const useTermsAndPoliciesState = () => {
    const termsAndPoliciesState = useSelector((state: RootState | any) => state.termsAndPolicies as TermsAndPoliciesState);
    return termsAndPoliciesState;
}

// Define the initial state using that type
const initialState: TermsAndPoliciesState = {
    termsAndPolicies: undefined,
    acceptedTOS: undefined,
}

export const termsAndPoliciesSlice = createSlice({
    name: 'termsAndPolicies',
    initialState,
    reducers: {
        setTermsAndPoliciesAction: (state, action: PayloadAction<TermsAndPolicies>) => {
            
            state.termsAndPolicies = action.payload;
        },
        setAcceptedTOSAction: (state, action: PayloadAction<boolean>) => {
            state.acceptedTOS = action.payload;
        }
    }
})

export const { setTermsAndPoliciesAction, setAcceptedTOSAction } = termsAndPoliciesSlice.actions;

export default termsAndPoliciesSlice.reducer;